import {Grid} from "@mui/material";
import ProjectsListContainer from "../components/home/ProjectsListContainer";
import MapContainer from "../components/home/MapContainer";
import {useSelector} from "react-redux";

const HomePage = () => {

    const localStorageProjects = useSelector((state) => state.projects.openLocalStorage);

    if (!localStorageProjects) return <></>;

    return (
        <>
            <Grid container sx={{height: '100%', width: '100%'}}>
                <Grid item xs={12} lg={3} xl={3}>
                    <ProjectsListContainer/>
                </Grid>
                <Grid item xs={12} lg={9} xl={9}>
                    <MapContainer/>
                </Grid>
            </Grid>
        </>
    )
}

export default HomePage;